import { useEffect, useState } from "react";
export function useColorMode() {
    const [mode, setMode] = useState(() => document.documentElement.classList.contains("dark") ? "dark" : "light");
    useEffect(() => {
        const obs = new MutationObserver(() => {
            setMode(document.documentElement.classList.contains("dark") ? "dark" : "light");
        });
        obs.observe(document.documentElement, { attributeFilter: ["class"] });
        return () => obs.disconnect();
    }, []);
    return mode;
}
